// extracted by mini-css-extract-plugin
export var chatHtmlText = "_t8-2";
export var chatLink = "_t8-0";
export var chatText = "_t8-1";